export default [
  {
    path: '/contracts',
    name: 'Contract_List',
    component: () => import('@/views/contracts/list.vue'),
    meta: { authRequired: true, permission: 'contracts.index' },
  },
  {
    path: '/contracts/create',
    name: 'Contract_Create',
    component: () => import('@/views/contracts/create.vue'),
    meta: { authRequired: true, permission: 'contracts.store' },
  },
  {
    path: '/contracts/:id',
    name: 'Contract_Detail',
    component: () => import('@/views/contracts/detail.vue'),
    meta: { authRequired: true, permission: 'contracts.index' },
  },
  {
    path: '/contracts/:id/edit',
    name: 'Contract_Edit',
    component: () => import('@/views/contracts/edit.vue'),
    meta: { authRequired: true, permission: 'contracts.update', navActiveLink: 'Contract_List' },
  },
]